import { RedoOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Card, Input, Spin } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import CartesianGrid from "recharts/lib/cartesian/CartesianGrid";
import YAxis from "recharts/lib/cartesian/YAxis";
import Legend from "recharts/lib/component/Legend";

import { getSupaClient } from "../../lib/supabase";

const DynamicKeywords = (props) => {
  // props.startTime (required)
  // props.endTime (required)
  const [keywordsData, setKeywordsData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const teamId = localStorage.getItem("team-id");
  const supaClient = getSupaClient();

  const searchKeyword = async () => {
    setLoading(true);
    const params = {
      start_time: props.startTime,
      end_time: props.endTime,
      team_id: teamId,
      keyword,
    };
    const { data, error } = await supaClient.rpc("keyword_counts", params);
    setLoading(false);
    if (error) console.log("error in searchKeyword", error);
    else {
      setKeywordsData(data);
      console.log("got keywordsData", data);
    }
  };

  const onKeywordChange = async (event) => {
    setKeyword(event.target.value);
  };

  // search again when time updates and keyword is not empty
  useEffect(() => {
    if (keyword) {
      searchKeyword();
    }
  }, [props.startTime, props.endTime]);

  return (
    <Card
      title="Keyword tracker"
      bordered={false}
      extra={
        <div className="flex flex-row justify-items-end space-x-2">
          <Input
            placeholder="Enter text"
            value={keyword}
            onChange={onKeywordChange}
          />
          <Button onClick={searchKeyword}>
            <div className="-mt-1">
              <SearchOutlined />
            </div>
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div style={{ width: "100%", height: "250px", paddingBottom: 10 }}>
          {keywordsData.length === 0 ? (
            <div className="flex justify-center">
              <div className="pt-5 text-gray-500 text-lg ">
                Please search a keyword to see the mentions over time!
              </div>
            </div>
          ) : (
            <ResponsiveContainer>
              <LineChart
                width={730}
                height={250}
                data={keywordsData}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="for_date"
                  tickFormatter={(date) => moment(date).format("MM/DD")}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="parent_count"
                  name="posts with keyword"
                  stroke="#8884d8"
                  strokeWidth={2}
                  activeDot={{ r: 8 }}
                />
                <Line
                  type="monotone"
                  dataKey="total_count"
                  name="posts + replies with keyword"
                  stroke="#82ca9d"
                  strokeWidth={2}
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
          )}
        </div>
      </Spin>
    </Card>
  );
};

export default DynamicKeywords;
